import React from "react"

function IconFileImage({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="file-image"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-file-image"
      {...props}
    >
      <path
        d="M19.076 21.853c.932 0 1.697-.716 1.775-1.628l.006-.153V7.816a.655.655 0 0 0-.12-.38l-.066-.078-4.87-4.98a.655.655 0 0 0-.363-.188l-.105-.008H5.054c-.931 0-1.697.715-1.775 1.626l-.006.154v16.11c0 .931.716 1.696 1.628 1.774l.153.007h14.022zm0-1.31H5.054a.473.473 0 0 1-.465-.387l-.007-.084V3.962c0-.23.167-.424.387-.463l.085-.008h9.625v4.325c0 .325.238.595.549.646l.106.008h4.213l.001 11.602a.473.473 0 0 1-.307.442l-.08.022-.085.008zm-.43-13.381h-2.658V4.444l2.658 2.718zm-10.11 4.25a1.778 1.778 0 1 0 0-3.555 1.778 1.778 0 0 0 0 3.556zm-2.668 4.016v3.984h12.445v-6.984l-2.666-2.793-5.48 5.644-2.076-2.088-2.223 2.237z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconFileImage
